import * as React from 'react'

import { cn } from '@/lib/utils'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<
  HTMLInputElement,
  InputProps & { error?: boolean }
>(({ className, type, error, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        ' flex h-10 w-full rounded-md border border-border bg-input px-3 py-2 text-sm  outline-none file:border-0 file:bg-transparent file:text-sm file:font-medium  placeholder:text-muted-foreground/50   focus-visible:ring-2 focus-visible:ring-accent disabled:cursor-not-allowed disabled:opacity-50',
        {
          'border-destructive text-red-600 focus-visible:ring-destructive':
            !!error,
        },
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = 'Input'

export { Input }
